import type { WritableComputedRef } from 'vue'
import type { Service } from '@/types'

/**
 * The service a ServiceEditor is editing, provided to the model editors under it. A model editor receives only
 * the model, and two things need the service around it: Filter when is a property of the service, and a fan-in
 * reads the service before it. Assigning to the ref emits the editor's update, as editing the model does.
 */
export type EditedServiceContext = WritableComputedRef<Service | null>

/** provide/inject key for {@link EditedServiceContext}. */
export const EDITED_SERVICE_KEY = 'builderEditedService'
